/* eslint-disable global-require */
import 'core-js';
import { shouldPolyfill as shouldPolyfillPluralRules } from '@formatjs/intl-pluralrules/should-polyfill';
import { shouldPolyfill as shouldPolyfillRelativeTimeFormat } from '@formatjs/intl-relativetimeformat/should-polyfill';

require('@formatjs/intl-getcanonicallocales/polyfill');
require('@formatjs/intl-locale/polyfill');

/* istanbul ignore if */
if (shouldPolyfillPluralRules()) {
  /* istanbul ignore next */
  require('@formatjs/intl-pluralrules/polyfill');
  /* istanbul ignore next */
  require('@formatjs/intl-pluralrules/locale-data/en'); // Add locale data for en
  /* istanbul ignore next */
  require('@formatjs/intl-pluralrules/locale-data/es'); // Add locale data for es
}

/* istanbul ignore if */
if (shouldPolyfillRelativeTimeFormat()) {
  /* istanbul ignore next */
  require('@formatjs/intl-relativetimeformat/polyfill');
  /* istanbul ignore next */
  require('@formatjs/intl-relativetimeformat/locale-data/en'); // Add locale data for en
  /* istanbul ignore next */
  require('@formatjs/intl-relativetimeformat/locale-data/es'); // Add locale data for es
}
